module.exports = __webpack_public_path__ + "static/media/42-9.5478df2b.mp3";